var _path, _path2, _path3, _path4, _path5, _path6, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImproveSub(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 36,
    viewBox: "0 0 37 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.0218 35.9995C27.975 35.9995 36.0437 27.9408 36.0437 17.9998C36.0437 8.05877 27.975 0 18.0218 0C8.06866 0 0 8.05877 0 17.9998C0 27.9408 8.06866 35.9995 18.0218 35.9995Z",
    fill: "url(#paint0_linear_2366_3194)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.2691 19.0434C25.4672 19.0434 26.4385 18.018 26.4385 16.7531C26.4385 15.4883 25.4672 14.4629 24.2691 14.4629C23.0709 14.4629 22.0996 15.4883 22.0996 16.7531C22.0996 18.018 23.0709 19.0434 24.2691 19.0434Z",
    fill: "#33160E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7749 19.0434C12.9731 19.0434 13.9444 18.018 13.9444 16.7531C13.9444 15.4883 12.9731 14.4629 11.7749 14.4629C10.5768 14.4629 9.60547 15.4883 9.60547 16.7531C9.60547 18.018 10.5768 19.0434 11.7749 19.0434Z",
    fill: "#33160E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1251 9.51172C12.1251 9.51172 12.5101 12.2234 7.08008 12.6548",
    stroke: "#33160E",
    strokeWidth: 1.64614,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M23.92 9.51172C23.92 9.51172 23.535 12.2234 28.965 12.6548",
    stroke: "#33160E",
    strokeWidth: 1.64614,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9531 23.9525C13.9531 23.9525 18.4696 22.2313 21.7017 23.9525",
    stroke: "#33160E",
    strokeWidth: 1.64614,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2366_3194",
    x1: 18.0218,
    y1: 0,
    x2: 18.0218,
    y2: 35.9995,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEEE85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.645833,
    stopColor: "#FECE47"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImproveSub);
export default __webpack_public_path__ + "static/media/improveSub.f2179988c93f368013a102062d03c000.svg";
export { ForwardRef as ReactComponent };